/* @flow */
import { ActionTypes } from '../constants/ChatSettingsConstants';
import Store from 'lib/Store';

// Note: Flux stores are now a DEPRECATED pattern. See docs/GraphQL.md
class ChatSettingsStore extends Store {
  getInitialState() {
    return {
      officeHours: null,
    };
  }

  getOfficeHours() {
    return this.state.officeHours;
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.OFFICE_HOURS_LOADED:
      case ActionTypes.OFFICE_HOURS_ENABLED:
      case ActionTypes.OFFICE_HOURS_DISABLED:
      case ActionTypes.OFFICE_HOURS_UPDATED:
        this.state.officeHours = action.hours;
        this.emitChange();
        break;
      default:
        break;
    }
  }
}

export default new ChatSettingsStore();
